import { capitalise } from './capitalise';
import { replaceCharacter } from './replaceCharacter';

export const vendorTypeToReadableSEOType = (type, makePlural = true) => {
  if (!type) return '';
  return `${capitalise(
    replaceCharacter(makePlural ? pluralise(type) : type, '-', ' ')
  )}`;
};
